import { createSelector } from 'reselect'

const sortGLCodesByName = (glCodeA, glCodeB) => {
  return glCodeA.value?.name
    ?.replace(/\W+/g, '')
    ?.localeCompare(glCodeB.value?.name?.replace(/\W+/g, ''))
}

const getGLCodes = ({ glCode }) => glCode.records
const getFetchingExpenseGlCodes = ({ glCode }) => glCode.fetchingExpenseGlCodes
const getExpenseGlCodes = ({ glCode }) => glCode.expenseCategoryGlCodes
const getGLCodeByName = ({ glCode }, name) =>
  glCode.records.find((glCode) => glCode?.value?.name === name)

const glCodeSelectors = {
  getGLCodeOptions: createSelector([getGLCodes], (glCodes) => {
    return [...glCodes].sort(sortGLCodesByName)
  }),

  getGLCodeByName: createSelector([getGLCodeByName], (glCode) => glCode),

  getFetchingExpenseGlCodes: createSelector(
    [getFetchingExpenseGlCodes],
    (fetchingExpenseGlCodes) => fetchingExpenseGlCodes,
  ),
  getExpenseGlCodes: createSelector([getExpenseGlCodes], (glCodes) => glCodes),
}

export default glCodeSelectors
